'use strict';

/**
 * @link https://github.com/World-Architects/WA3/issues/2506
 */
let waFilterBar = {
	postFilters: function () {
		// Store current scroll position before submitting
		sessionStorage.setItem('filterScrollPosition', window.scrollY);
		document.getElementById('filter-form').submit();
	},

	restoreScrollPosition: function () {
		// Restore scroll position after page load
		const scrollPos = sessionStorage.getItem('filterScrollPosition');
		if (scrollPos !== null) {
			window.scrollTo(0, parseInt(scrollPos));
			sessionStorage.removeItem('filterScrollPosition');
		}
	}
};

// Restore scroll position on page load if it was stored
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function() {
		waFilterBar.restoreScrollPosition();
	});
} else {
	waFilterBar.restoreScrollPosition();
}
